import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { cloneDeep, defaultsDeep, map } from 'lodash';
import { map as rxMap } from 'rxjs';

import {
  NAV_DEFINITION,
  createRlaLinks,
} from '@lockton-apps/shared/util/constants';
import {
  selectFooterNav,
  selectPrimaryNav,
  selectUserMenu,
} from './core.selectors';

@Injectable()
export class CoreFacade {
  private store = inject(Store);

  private navDefinition = inject(NAV_DEFINITION);

  primaryNav$ = this.store.select(selectPrimaryNav).pipe(
    rxMap((rlaConfig) => {
      return createRlaLinks(cloneDeep(rlaConfig), this.navDefinition);
    })
  );

  userMenu$ = this.store.select(selectUserMenu).pipe(
    rxMap((rlas) => {
      return map(rlas, (rla) =>
        rla.id === 'logout' && rla.type === 'action'
          ? defaultsDeep(
              {
                cb: () => {
                  return this.store.dispatch(rla.cb());
                },
              },
              rla
            )
          : rla
      );
    })
  );

  footerNav$ = this.store.select(selectFooterNav).pipe(
    rxMap((rlaConfig) => {
      return createRlaLinks(cloneDeep(rlaConfig), this.navDefinition);
    })
  );
}
